import { createStyles, makeStyles } from "@material-ui/core";
import {
    Breakpoint,
    LogoWithTextBeside,
    MobileTitleBar,
    RelodeTheme,
    useDeviceSize,
} from "@relode/core";
import classnames from "classnames";
import * as React from "react";
import { Route, Switch } from "react-router";

import { ClientPublicCandidateDetailsContainer } from "../public/candidate/details/clientPublicCandidateDetailsContainer";
import { ClientPublicJobDetailsContainer } from "../public/job";
import { ClientPublicMarketResearchContainer } from "../public/marketResearch/clientPublicMarketResearchContainer";
import { useStyles } from "./app.styles";
import { RouteNotFound } from "./routeNotFound";

const usePublicStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            titleBar: {
                position: "fixed",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: theme.relode.sizes.mobileAppBarHeight,
                borderBottom: `1px solid ${theme.palette.divider}`,
                backgroundColor: "white",
                padding: 8,
                width: "100%",
                zIndex: 1000,
            },
            logo: {
                cursor: "pointer",
            },
        }),
    { name: "PublicApp" }
);

export const PublicApp = () => {
    const classes = useStyles({});
    const publicClasses = usePublicStyles({});
    const device = useDeviceSize();

    const bodyWrapperClassNames = classnames({
        [classes.bodyWrapper]: true,
        [classes.mobileBodyWrapper]: device === "mobile",
    });

    return (
        <div className={classes.root}>
            <Breakpoint mobile>
                <MobileTitleBar>
                    <div className={classes.logo}>
                        <div
                            className={publicClasses.logo}
                            id="logoButton"
                            title="to relode.com"
                            onClick={() =>
                                (window.location.href =
                                    "https://www.relode.com")
                            }
                        >
                            <LogoWithTextBeside
                                height={19}
                                textColor="#33006e"
                            />
                        </div>
                    </div>
                </MobileTitleBar>
            </Breakpoint>
            <div className={bodyWrapperClassNames}>
                <div className={classes.contentView}>
                    <Switch>
                        <Route
                            path="/public/candidate"
                            exact
                            component={ClientPublicCandidateDetailsContainer}
                        />
                        <Route
                            path="/public/job"
                            exact
                            component={ClientPublicJobDetailsContainer}
                        />
                        <Route
                            path="/public/market-research"
                            exact
                            component={ClientPublicMarketResearchContainer}
                        />
                        <Route component={RouteNotFound} />
                    </Switch>
                </div>
            </div>
        </div>
    );
};
